export const lineLeaderPurple = '#C199D5';
export const lineLeaderDarkerPurple = '#4921DE';
export const reportPrimary = '#03A9F4';
export const reportBg = '#92DCFE';
export const reportChipBg = '#92DCFE';
export const lineLeaderReportPrimary = 'var(--primary-color)';
export const lineLeaderReportBg = 'var(--primary-light)';
export const lineLeaderChipBg = 'var(--primary-supersuperlight)';
